/* eslint-disable no-else-return */
import React, { useState, useEffect } from 'react';
import { Container, Typography, Paper, Box, Grid, Button, Tooltip } from '@mui/material';
import { HealthService } from '../application/HealthService';
import Page from '../components/Page';

const healthService = new HealthService();


const formatToTaiwanTime = (dateString) => {
  const date = new Date(dateString);
  date.setHours(date.getHours() + 8);
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    timeZone: 'Asia/Taipei'
  };
  return date.toLocaleString('zh-TW', options).replace(/\//g, '-');
};
const UptimeIndicator = ({ beats }) => (
  <Box sx={{ display: 'flex', height: 20, width: '100%', bgcolor: '#f0f0f0', borderRadius: 1, overflow: 'hidden' }}>
    {beats.map((beat, index) => (
      <Tooltip key={index} title={`${formatToTaiwanTime(beat.time)}`}>
        <Box
          sx={{
            flex: 1,
            bgcolor: (() => {
              if (beat.status === 1) return '#4caf50';
              if (beat.status === 2) return '#ff9800';
              return '#f44336';
            })(),
            borderRight: index < beats.length - 1 ? '1px solid #ffffff' : 'none'
          }}
        />
      </Tooltip>
    ))}
  </Box>
);

const SystemHealth = () => {
  const cityMapping = {
    '台北市': 'taipei',
    '嘉義市': 'chiayi',
    '台南市': 'tainan',
    '彰化縣': 'changhua',
    '雲林縣': 'yunlin'
  };
  const [healthData, setHealthData] = useState(null);
  const Region = localStorage.getItem('region');

  const mappedRegion = cityMapping[Region];

  useEffect(() => {
    fetchHealthData();
    const interval = setInterval(fetchHealthData, 120000);
    return () => clearInterval(interval);
  }, []);

  const fetchHealthData = async () => {
    try {
      const data = await healthService.getHealthStatus(mappedRegion);
      setHealthData(data);
    } catch (error) {
      console.error('獲取健康數據時出錯：', error);
    }
  };
  const calculateUptimePercentage = (beats) => {
    const upBeats = beats.filter(beat => beat.status === 1).length;
    return ((upBeats / beats.length) * 100).toFixed(2);
  };



  const getTimeDifference = (oldestBeatTime) => {
    const now = new Date();
    const oldestTime = new Date(oldestBeatTime);

    // 手動添加 8 小時的時差
    oldestTime.setHours(oldestTime.getHours() + 8);

    const diffInMinutes = Math.floor((now - oldestTime) / (1000 * 60));

    if (diffInMinutes < 60) {
      return `${diffInMinutes} 分鐘前`;
    } else if (diffInMinutes < 1440) {
      const hours = Math.floor(diffInMinutes / 60);
      return `${hours} 小時前`;
    } else {
      const days = Math.floor(diffInMinutes / 1440);
      return `${days} 天前`;
    }
  };

  if (!healthData) return <Typography>載入中...</Typography>;

  return (
    <Page title="系統健康度 | 智慧城市移動資訊平台">
      <Box sx={{ bgcolor: '#ffffff', minHeight: '100vh', py: 4 }}>
        <Container maxWidth="lg">
          <Typography variant="h4" sx={{ mb: 3, fontWeight: 'bold', color: '#333333' }}>
            {healthData.title}
          </Typography>

          <Paper sx={{ p: 3, mb: 4, bgcolor: '#f9f9f9', color: '#333333', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
            <Typography variant="body1">
              {healthData.description}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              sx={{ mt: 2 }}
              onClick={() => window.open('https://www.reversemonitor.smartbustw.com/status/0', '_blank')}
            >
              開啟狀態頁
            </Button>
          </Paper>

          {healthData.monitors.map((monitor) => (
            <Box key={monitor.monitor_id} sx={{ mb: 4 }}>
              <Typography variant="h5" sx={{ mb: 2, fontWeight: 'semibold', color: '#333333' }}>
                {monitor.name}
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Paper sx={{ p: 3, bgcolor: '#ffffff', color: '#333333', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                      <Typography variant="h6" sx={{ fontWeight: 'medium' }}>
                        {monitor.name}
                      </Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box
                          sx={{
                            width: 8,
                            height: 8,
                            borderRadius: '50%',
                            mr: 1,
                            bgcolor: (() => {
                              const { status } = monitor.beats[monitor.beats.length - 1];
                              if (status === 1) return '#4caf50';
                              if (status === 2) return '#ff9800';
                              return '#f44336';
                            })()
                          }}
                        />
                        <Typography variant="body2">
                          {monitor.beats[monitor.beats.length - 1].status === 1 ? '正常運行' : '異常'}
                        </Typography>
                      </Box>
                    </Box>
                    <UptimeIndicator beats={monitor.beats.slice(-60)} />
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                      <Typography variant="caption" color="textSecondary">
                        {getTimeDifference(monitor.beats[0].time)}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">現在</Typography>
                    </Box>
                    <Typography variant="body2" sx={{ mt: 2, color: '#666666' }}>
                      最後更新時間：{formatToTaiwanTime(monitor.beats[monitor.beats.length - 1].time)}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#666666' }}>
                      當前回應時間：{monitor.beats[monitor.beats.length - 1].ping} 毫秒
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#666666' }}>
                      運行時間比例： {calculateUptimePercentage(monitor.beats)}%
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          ))}
        </Container>
      </Box>
    </Page>

  );
};

export default SystemHealth;